export default "__VITE_ASSET__e8jmp2Dj__"